import styled from 'styled-components';
import PropTypes from 'prop-types';

const OL = styled.ol`
  margin-top: ${(props) => (props.resetMargin ? 0 : null)};
  padding-left: ${(props) => props.paddingLeft};
  margin-bottom: ${(props) => props.marginBottom};

  /**
   * Vertical margin reset.
   * Added because some frontlib-gui styles add margins that could create inconsistent spacing.
  */
  & > * {
    margin-top: 0;
    margin-bottom: 0;
  }

  /** The owl selector (* + *) ignores the first list item and adds top margin all other list items.*/
  > * + * {
    margin-top: ${(props) => props.space};
  }
`;

OL.propTypes = {
  /**
   * Overrides the default padding added by browsers.
   * Defaults to 18px so the list items sit against the left edge of the container.
   */
  paddingLeft: PropTypes.string,
  /** Overrides the margin with a default of zero **/
  marginBottom: PropTypes.string,
  /**
   * Browsers add top and bottom margin to the `ul` element by default.
   */
  resetMargin: PropTypes.bool,
  /**
   * A CSS margin value.
   * Design would like us to use multiples of 8, e.g., .8rem, 1.6rem, 2.4rem, 3.2rem, 4rem, etc.
   * For accessibility reasons, `space` uses `rem` as a unit in order to support members who need customize their font sizes.
   * `px` can still be used, however.
   * Defaults to 1.6rem because that is the most commonly used spacing value.
   */
  space: PropTypes.string,
};

OL.defaultProps = {
  paddingLeft: '18px',
  marginBottom: '0',
  resetMargin: true,
  space: '1.6rem',
};

export default OL;
